//REV-21373 — Vokabular der Detailansicht EINES Eintrags (Kommentar oder Pendenz).
//
//⚠️ EINE Komponente mit zwei Auspraegungen (ADR-0019 E7), wie die Uebersicht.

import { NoteAnchor, NoteAuthor, NoteKind, NoteReply, NoteSource, NoteTag } from '../account-notes/account-notes.types';

export { NoteAnchor, NoteAuthor, NoteKind, NoteReply, NoteSource, NoteTag };

/**
 * Eine Zeile der Zusammenfassung — **anzeige-fertig**.
 *
 * ⚠️ Was es fuer die Art nicht gibt, kommt GAR NICHT herein (AC3). Ein leeres „Faellig" an einem
 * Kommentar behauptet ein Feld, das es nicht gibt — das ist schlimmer als eine fehlende Zeile.
 */
export interface NoteDetailFact {
    /** Maschinenlesbar fuer den Contract: `status` | `tags` | `assignee` | `account` | … */
    key: NoteDetailFactKey;
    /** Fertig uebersetzte Beschriftung. */
    label: string;
    /** Fertig formatierter Wert. `null` ⇒ die Zeile erscheint NICHT. */
    value: string | null;
}

export type NoteDetailFactKey = 'status' | 'tags' | 'assignee' | 'account' | 'created' | 'author' | 'due';

/** Welche Felder der Verfasser aendern darf (AC6). Eine Konto-Pendenz gibt weniger frei. */
export type NoteEditableField = 'text' | 'description' | 'tags' | 'due' | 'assignee' | 'account';

export interface NoteDetail {
    id: string;
    kind: NoteKind;
    source: NoteSource;
    /** Der Text steht im Kopf; an einer erledigten Pendenz durchgestrichen (AC2). */
    text: string;
    /**
     * Die Erläuterung unter dem Titel. `null` ⇒ die Zeile erscheint GAR NICHT — dieselbe
     * Regel wie bei den übrigen Feldern (AC3): ein leerer Kasten behauptet ein Feld, das
     * dieser Eintrag nicht hat.
     */
    description?: string | null;
    /**
     * Die Fälligkeit als ROHWERT `JJJJ-MM-TT` — für das Datumsfeld im Formular.
     *
     * ⚠️ ZUSÄTZLICH zur Zeile in `facts`, nicht statt ihrer. Die Zusammenfassung zeigt
     * `08.09.2026`, ein `input[type=date]` versteht aber nur `2026-09-08` — und der Server
     * nimmt ohnehin nur ISO. Das Schweizer Datum dafür zurückzuparsen hiesse, dasselbe Datum
     * zweimal zu formatieren und einmal davon falsch.
     */
    dueValue?: string | null;
    tags: NoteTag[];
    author: NoteAuthor;
    /** Das zitierte Stueck unter dem Kopf. `null` ⇒ kein Zitat. */
    anchor?: NoteAnchor | null;
    accountLabel?: string | null;
    accountId?: string | null;
    /**
     * The assignee's user id, for the edit field. The fact `assignee` carries the NAME;
     * seeding the field from it selected nothing and saved the name as an id.
     */
    assigneeId?: string | null;
    /** Die Zusammenfassung, bereits auf das reduziert, was es fuer diese Art gibt. */
    facts: NoteDetailFact[];
    replies: NoteReply[];
    done?: boolean;
    /**
     * Rechte am Eintrag (ADR-0019 E9). Ohne Recht ist der Knopf ABWESEND, nicht ausgegraut.
     *
     * ⚠️ Der Pure View entscheidet nichts davon — er liest es am Eintrag.
     */
    canEdit: boolean;
    canDelete: boolean;
    /** Nur der Verfasser darf zuweisen (ADR-0019 E9) — und zwar IM Formular, nicht als Extra-Knopf. */
    editableFields: NoteEditableField[];
}

export interface NoteDetailEditSubmit {
    id: string;
    text: string;
    description?: string | null;
    tags: NoteTag[];
    /**
     * Nur mitgeschickt, wenn das Feld freigegeben ist. `JJJJ-MM-TT` oder `null`.
     *
     * ⚠️ Ein ROHWERT, kein Label — der Name sagte früher das Gegenteil, und das war der
     * Fehler: die Ansicht schickte `08.09.2026` los, und der Server nimmt nur ISO-8601.
     */
    dueValue?: string | null;
    assigneeId?: string | null;
    accountId?: string | null;
}

export interface NoteDetailReplySubmit {
    noteId: string;
    text: string;
}

/** Eine Person fuer das Zuweisen-Feld. Kommt herein — ein Pure View laedt keine Benutzer. */
export interface NoteAssignee {
    userId: string;
    displayName: string;
}

/**
 * Ein Konto für das Konto-Feld. Kommt herein — ein Pure View lädt keine Konten.
 *
 * ⚠️ Nummer und Name GETRENNT, aus demselben Grund wie in der Tabelle: die Auswahlliste
 * setzt die Nummer voran, damit man sie tippen kann.
 */
export interface NoteAccountOption {
    accountId: string;
    number: string;
    name: string;
}
